import { Aircraft } from 'domain/entities/Aircraft';

export const getAircraftOptionName = (
  aircraft: Pick<Aircraft, 'type' | 'code' | 'serialNumber'>,
) => {
  return [aircraft.type?.name, aircraft.code || aircraft.serialNumber].filter(Boolean).join(' - ');
};
